module.exports = {
  "zones": {
    "Africa/Johannesburg": ["z", {
      "wallclock": -2109283200000,
      "format": "SAST",
      "abbrev": "SAST",
      "offset": 7200000,
      "posix": -2109288600000,
      "save": 0,
      "rules": "SA"
    }, {
      "wallclock": -2458166400000,
      "format": "SAST",
      "abbrev": "SAST",
      "offset": 5400000,
      "posix": -2458173120000,
      "save": 0
    }, {
      "wallclock": -1.7976931348623157e+308,
      "format": "LMT",
      "abbrev": "LMT",
      "offset": 6720000,
      "posix": -1.7976931348623157e+308,
      "save": 0
    }]
  },
  "rules": {
    "SA": [{
      "from": 1943,
      "to": 1944,
      "month": 2,
      "day": [0, 15],
      "time": 120,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1942,
      "to": 1943,
      "month": 8,
      "day": [0, 15],
      "time": 120,
      "clock": "wallclock",
      "save": 60,
      "letter": "",
      "saved": 0
    }]
  }
};